var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('app-sider'),_c('section',{staticClass:"app-layout-main"},[_c('app-header'),_c('app-body')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }